import moment from 'moment'
import { dateTimeFormat, dateFormat } from './constants'

moment.locale('es')

export const genBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (e) => resolve(e.target.result.replace('data:', '').replace(/^.+,/, ''))
    reader.onerror = (error) => reject(error)
  })

export const sanitizeHtml = (html) => {
  if (html.indexOf('<img') === 0) {
    return `<p style="all:unset;"></p>${html}`
  }
  return html
}

export const formatDateTime = (dateTime) =>
  dateTime ? moment(dateTime).format(dateTimeFormat) : ''
export const formatDate = (dateTime) => (dateTime ? moment(dateTime).format(dateFormat) : '')

export const getInputValue = (target) => {
  switch (target.type) {
    case 'checkbox':
      return target.checked
    case 'number':
      return target.value !== '' ? Number(target.value) : ''
    default:
      return target.value
  }
}

export const currencyFormat = function (number) {
  return number
    ? new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      }).format(number)
    : '--'
}
